import React, { useState } from 'react';
import { HelpOutline, Close } from '@material-ui/icons';
import { Formik } from 'formik';
import {
    TextField,
    Typography,
    Tooltip,
    IconButton,
    withStyles,
    Select,
    MenuItem,
    FormControl,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Button,
    InputLabel,
    CircularProgress
} from '@material-ui/core';
import * as Yup from 'yup';
import FormStep2 from './FormStep2';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    button: {
        width: '120px',
        marginTop: '10px',
        marginRight: '10px'
    },
    formControl: {
        width: '100%'
    }
});

const FormStep1Makor = props => {
    const {
        classes,
        formSettings,
        initialValues,
        translations,
        handleSubmit,
        isDirty,
        edit
    } = props;

    const [mappingHelp, setMappingHelp] = useState(false);
    const handleMappingHelp = () => {
        setMappingHelp(!mappingHelp);
    };

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={Yup.object().shape(formSettings.Validation)}
            onSubmit={async (values, { setSubmitting }) => {
                setSubmitting(true);
                await handleSubmit(values);
            }}
            validateOnMount={true}
        >
            {formikProps => {
                const { values, dirty, touched, errors, isValid, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;

                return (
                    <div className={classes.root}>
                        <form onSubmit={handleSubmit}>
                            <>
                                <TextField
                                    name="Name"
                                    value={values.Name}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={!!(errors.Name && touched.Name)}
                                    placeholder={translations["name"] || "Name"}
                                    label={translations["name"] || "Name"}
                                    margin={"dense"}
                                    fullWidth={true}
                                />
                                <FormControl id="direction_select" className={classes.formControl} margin={"dense"}>
                                    <InputLabel shrink>{translations['please_select_direction'] || "Please select direction"}</InputLabel>
                                    <Select
                                        name="Direction"
                                        label={translations['direction'] || 'Direction'}
                                        margin={"dense"}
                                        value={values.Direction}
                                        onChange={handleChange}
                                    >
                                        <MenuItem value={"in"}>
                                            {translations['in'] || 'in'}
                                        </MenuItem>
                                        <MenuItem value={"out"}>
                                            {translations['out'] || 'out'}
                                        </MenuItem>
                                        <MenuItem value={"in+out"}>
                                            {`${translations['in'] || 'in'}+${translations['out'] || 'out'}`}
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                                <FormControl id="active_select" className={classes.formControl} margin={"dense"}>
                                    <InputLabel shrink>{translations["active"] || "Active"}</InputLabel>
                                    <Select
                                        name="Active"
                                        value={values.Active}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={!!(errors.Active && touched.Active)}
                                        placeholder={translations["active"] || "Active"}
                                        label={translations["active"] || "Active"}
                                        margin={"dense"}
                                        fullWidth={true}
                                    >
                                        <MenuItem value={true}>
                                            {translations['active'] || 'Active'}
                                        </MenuItem>
                                        <MenuItem value={false}>
                                            {translations['inactive'] || 'Inactive'}
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                                <TextField
                                    name="Hostname"
                                    value={values.Hostname}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={!!(errors.Hostname && touched.Hostname)}
                                    placeholder={translations["hostname"] || "Hostname"}
                                    label={translations["hostname"] || "Hostname"}
                                    margin={"dense"}
                                    fullWidth={true}
                                />
                                <TextField
                                    name="Path"
                                    value={values.Path}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={!!(errors.Path && touched.Path)}
                                    placeholder={translations['path'] || 'Path'}
                                    label={translations['path'] || 'Path'}
                                    margin={'dense'}
                                    fullWidth={true}
                                />
                                {mappingHelp ? <Tooltip title={translations["close_mapping_help"] || "Close mapping help screen"}>
                                    <IconButton onClick={handleMappingHelp}>

                                        <Close />
                                    </IconButton>
                                </Tooltip>
                                    :
                                    <Tooltip title={translations["need_help_mapping"] || "Need help with table mapping?"}>
                                        <IconButton onClick={handleMappingHelp}>

                                            <HelpOutline />
                                        </IconButton>
                                    </Tooltip>
                                }
                                {
                                    mappingHelp ?
                                        <Typography>
                                            The Makor key should be on the left side, and the Securaze erasure method key on the right.
                                        </Typography>
                                        : null
                                }
                                <TextField
                                    name="ErasureMethodMapping"
                                    value={values.ErasureMethodMapping}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={!!(errors.ErasureMethodMapping && touched.ErasureMethodMapping)}
                                    placeholder={translations['erasure_method_mapping'] || 'Erasure method mapping'}
                                    label={translations['erasure_method_mapping'] || 'Erasure method mapping'}
                                    margin={'dense'}
                                    fullWidth={true}
                                />
                                <InputLabel shrink>{translations['select_external_behaviour'] || "Please select client behaviours"}</InputLabel>
                                {values.Direction.includes('in') ?
                                    <FormGroup row>
                                        <>
                                            <span style={{ 'vertical-align': 'middle', display: 'inline-flex', 'align-items': 'center', 'margin-right': '16px'}}>{`${translations['external_behaviour_provide_external_id'] || 'Provide External ID on device check for'}: `}</span>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={values.ProvideExternalIDEnabled.PCProduct}
                                                        onChange={handleChange}
                                                        name="ProvideExternalIDEnabled.PCProduct"
                                                        color="primary"
                                                    />
                                                }
                                                label={translations['pc_product'] || 'Work'}
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={values.ProvideExternalIDEnabled.MobileProduct}
                                                        onChange={handleChange}
                                                        name="ProvideExternalIDEnabled.MobileProduct"
                                                        color="primary"
                                                    />
                                                }
                                                label={translations['mobile_product'] || 'Mobile'}
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={values.ProvideExternalIDEnabled.StorageProduct}
                                                        onChange={handleChange}
                                                        name="ProvideExternalIDEnabled.StorageProduct"
                                                        color="primary"
                                                    />
                                                }
                                                label={translations['storage_product'] || 'Single disk-drives'}
                                            />
                                            {Object.keys(values.ProvideExternalIDEnabled).some(key => values.ProvideExternalIDEnabled[key]) ?
                                                <>
                                                    <TextField
                                                        name="ProvideExternalIDRegexp"
                                                        value={values.ProvideExternalIDRegexp}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        error={!!(errors.ProvideExternalIDRegexp && touched.ProvideExternalIDRegexp)}
                                                        placeholder={translations["external_id_regexp"] || "External ID Regexp (Leave empty for no regexp check)"}
                                                        label={translations["external_id_regexp"] || "External ID Regexp (Leave empty for no regexp check)"}
                                                        margin={"dense"}
                                                        fullWidth={true}
                                                    />
                                                    <TextField
                                                        name="ProvideExternalIDDescription"
                                                        value={values.ProvideExternalIDDescription}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        error={!!(errors.ProvideExternalIDDescription && touched.ProvideExternalIDDescription)}
                                                        placeholder={translations["external_id_regexp_description"] || "External ID Regexp Description"}
                                                        label={translations["external_id_regexp_description"] || "External ID Regexp Description"}
                                                        margin={"dense"}
                                                        fullWidth={true}
                                                    />
                                                    <TextField
                                                        name="ProvideExternalIDName"
                                                        value={values.ProvideExternalIDName}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        error={!!(errors.ProvideExternalIDName && touched.ProvideExternalIDName)}
                                                        placeholder={translations["external_id_name"] || "External ID Name on External Service"}
                                                        label={translations["external_id_name"] || "External ID Name on External Service"}
                                                        margin={"dense"}
                                                        fullWidth={true}
                                                    />
                                                </> : null
                                            }
                                        </>
                                    </FormGroup> : null
                                }

                                {values.Direction.includes('out') ?
                                    <FormGroup row>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={values.ConfirmDataExportEnabled}
                                                    onChange={handleChange}
                                                    name="ConfirmDataExportEnabled"
                                                    color="primary"
                                                />
                                            }
                                            label={translations['external_behaviour_confirm_data_export'] || 'Confirm data export'}
                                        />
                                        {values.ConfirmDataExportEnabled ?
                                            <TextField
                                                name="ConfirmDataExportMessage"
                                                value={values.ConfirmDataExportMessage}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                error={!!(errors.ConfirmDataExportMessage && touched.ConfirmDataExportMessage)}
                                                placeholder={translations["confirm_data_export_message"] || "Message for data export finished"}
                                                label={translations["confirm_data_export_message"] || "Message for data export finished"}
                                                margin={"dense"}
                                                fullWidth={true}
                                            /> : null
                                        }
                                    </FormGroup>
                                    : null
                                }
                            </>
                            <FormStep2 handleSubmit={handleSubmit} 
                                initialValues={initialValues} 
                                translations={translations} 
                                formSettings={formSettings} 
                                values={values} 
                                handleChange={handleChange}
                                handleBlur={handleBlur}
                                errors={errors}
                                touched={touched}
                                isSubmitting={isSubmitting}
                                isValid={isValid}
                                dirty={dirty}
                            />
                            {formSettings.ButtonSubmit ? (
                                <Button
                                    className={classes.submit}
                                    variant="contained"
                                    color={formSettings.ButtonSubmit.Color}
                                    type="submit"
                                    disabled={!edit ? !isValid || isSubmitting : !((isValid && dirty) || isDirty) || isSubmitting}
                                >
                                    {isSubmitting ? (
                                        <CircularProgress size={24} />
                                    ) : (
                                            formSettings.ButtonSubmit.Title
                                        )}
                                </Button>
                            ) : null}
                        </form>
                    </div>
                );
            }}
        </Formik>
    );
};

export default withStyles(styles, { withTheme: true })(FormStep1Makor);